module.exports = __webpack_public_path__ + "019f2e665289a9acc7498b92fc118356.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/campbell_soup_2022_chart.png
// module id = 1646
// module chunks = 0